module.exports = __webpack_public_path__ + "static/gallery_10-thumb-2ee1b554729d18de2fae66ba5604b8db.jpg";